import { useNavigate } from "react-router-dom";

const imageContainer = {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    gap: '10px',
}

const headStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const yearSelect = {
    width: '90px'
}

const imgContainer = { 
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '150px'
};

const img = {
    width: '150px',
    height: '150px',
    objectFit: 'cover', 
    borderRadius: '8px'
}

const Layout = ({ user, ...props }) => {
    const navigate = useNavigate();
    const data = [
        {"TemplateName":"Blank Template", "url":'/blankTemplate'},
        {"TemplateName":"other Template", "url":'/OtherTemplate'},
    ];
    
    return <div className="right_container">
                <div className="dashboard">
                    <div className='inner-content'>
                        <div style={imageContainer}>
                            {
                                data.map((item, index) => {
                                    return <div key={`container${index}`} style={imgContainer} onClick={() => {navigate(`${item?.url}`)}}>
                                    <img style={img} src='../../../../images/Files-Icon-PNG-HD-Quality.png' alt="image" /> 
                                    <p>{item?.TemplateName}</p>
                                </div>
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
    }


const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default Layout;